import { Avatar, Box, Button, List, ListItem, ListItemAvatar, ListItemText, makeStyles, TextField, Typography } from "@material-ui/core";
import CommentIcon from "@material-ui/icons/Comment";
import moment from "moment";
import * as React from "react";
import { useRef } from "react";
import { useDataProvider, useNotify } from "react-admin";
import CardWithIcon from "./CardWithIcon";

const ApprovedComments = (props: any) => {
  const dp = useDataProvider();
  const notify = useNotify();
  const classes = useStyles();

  const [comments, setComments] = React.useState(Array);
  const [buttons, setButtons] = React.useState(false);

  const addCommentHandle = () => {
    setButtons(true);
  };

  const cancelCommentHandle = () => {
    commentInput.current.value = "";
    setButtons(false);
  };

  let commentInput = useRef({ value: "" });

  const insertComment = () => {
    //Yorum bilgisini aldım.
    let comment = commentInput.current.value.trim();

    //Boş olup, olmadığını kontrol ettim.
    comment === "undefined" || comment === null || comment === ""
      ? notify("Enter comment", "warning")
      : dp
          .create("comments", { data: { videoId: props.record.id, userComment: comment, status: 1 } })
          .then(() => {
            notify("Your comment saved successfully and submitted for the admin approval. ", "success"), cancelCommentHandle();
          })
          .catch(() => {
            notify("An error was occured while adding the comment. Please try again.", "error");
          });
  };

  const GetAllComments = async () => {
    await dp
      .getList("comments", {
        pagination: { page: 1, perPage: 10 },
        sort: { field: "id", order: "DESC" },
        filter: { status__eq: "2", videoId__eq: props.record.id },
      })
      .then((res) => {
        setComments(res.data);
      });
  };

  React.useEffect(() => {
    GetAllComments();
  }, [dp]);

  return (
    <div>
      {true && (
        <CardWithIcon
          //to="/reviews"
          icon={CommentIcon}
          title="Comments"
          subtitle={comments.length > 0 ? comments.length : "0"}
        >
          <div className={classes.root}>
            <TextField
              id="standard-basic"
              label="Add a public comment"
              multiline
              fullWidth
              required
              className={classes.textField}
              inputRef={commentInput}
              onFocus={(e) => addCommentHandle()}
              //       onBlur={(e) => cancelCommentHandle()}
            />
            {buttons && (
              <div className={classes.commentButtons}>
                <Button onClick={(e) => cancelCommentHandle()} variant="contained" color="secondary" style={{ marginRight: "10px" }}>
                  Cancel
                </Button>
                <Button variant="contained" color="primary" onClick={(e) => insertComment()}>
                  Comment
                </Button>
              </div>
            )}
          </div>
          {
            comments && comments.length > 0 ? (
              <List>
                {Object.values(comments).map((record: any) => (
                  <ListItem
                    key={record.id}
                    button
                    //component={Link}
                    //to={`/reviews/${record.id}`}
                    alignItems="flex-start"
                  >
                    <ListItemAvatar>
                      <Avatar alt="Safebook" src="" />
                    </ListItemAvatar>
                    <ListItemText
                      primary={record.creatorName + " | " + moment(record.createdDate).format("DD.MM.YYYY")}
                      secondary={
                        <React.Fragment>
                          <Typography component="span" variant="body2" className={classes.listItemText} color="textPrimary">
                            {record.userComment}
                          </Typography>
                        </React.Fragment>
                      }
                      className={classes.listItemText}
                      style={{ paddingRight: 0 }}
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Box textAlign="left" m={1}>
                <Typography variant="body1">
                  <br />
                  No comments found
                </Typography>
              </Box>
            )
            // <CircularProgress />
          }
          <Box flexGrow="1">&nbsp;</Box>
        </CardWithIcon>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  avatar: {
    background: theme.palette.background.paper,
  },
  listItemText: {
    overflowY: "hidden",
    height: "4em",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
  link: {
    borderRadius: 0,
  },
  linkContent: {
    color: theme.palette.primary.main,
  },
  textField: {
    //paddingLeft: 20,
    //margin: 20
  },
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  commentButtons: {
    float: "right",
  },
}));

export default ApprovedComments;
